import React, { FC } from "react";

import { Card, Box, Skeleton, Stack } from "@components/base";

const OrganizationSettingsSkeleton: FC = () => (
  <Card>
    <Box p={2}>
      <Stack spacing={2}>
        <Skeleton height={200} />
        <Skeleton height={200} />
      </Stack>
    </Box>
  </Card>
);

export default OrganizationSettingsSkeleton;
